<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="LBLBASEINFO" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline>
                <!-- [S]결재관련 버튼 -->
                <!-- sysApprovalRequestId: 상세조회시 관련 결재요청일련번호 확인 -->
                <!-- param.isApprContent: 결재요청/결재처리 팝업의 component에 해당 페이지 호출시 true -->
                <!-- approvalStatusCd: 결재요청건에 대한 상태코드 -->
                <!-- param.approvalDocType: TODO(결재할문서에서 상세페이지호출시) -->
                <c-appr-btn
                  ref="appr-btn"
                  name="safety-gear-request-appr-btn"
                  :editable="editable"
                  :approvalInfo="approvalInfo"
                  @beforeApprAction="saveDataAppr"
                  @callbackApprAction="approvalCallback"
                  @requestAfterAction="getDetail"
                />
                <c-btn
                  v-if="editable && data.approvalStatusCd"
                  label="일지출력"
                  color="amber-7"
                  icon="print"
                  @btnClicked="print"
                />
                <c-btn
                  v-if="editable && popupParam.envAirDailyResultId"
                  label="전체화면 보기"
                  @btnClicked="fullScreenReport"
                  icon="receipt_long"
                />
                <c-btn
                  v-if="editable && updateMode && !data.approvalStatusCd"
                  label="LBLREMOVE"
                  icon="remove"
                  @btnClicked="deleteData"
                />
                <c-btn
                  v-if="editable && !data.approvalStatusCd"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="mappingType"
                  label="LBLSAVE"
                  icon="save"
                  @beforeAction="saveInfo"
                  @btnCallback="saveCallback"
                />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2">
                <c-datepicker
                  :required="true"
                  :editable="editable && !updateMode"
                  label="LBLREGDATE"
                  name="dailyResultDt"
                  v-model="data.dailyResultDt"
                />
              </div>
              <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <c-field
                  :required="true"
                  :editable="editable && !updateMode"
                  :data="data"
                  deptValue="deptCd"
                  type="dept_user"
                  label="작성부서 & 작성자"
                  name="userId"
                  v-model="data.userId"
                >
                </c-field>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2">
                <c-plant
                  :required="true"
                  :editable="editable && !updateMode"
                  type="edit"
                  name="plantCd"
                  v-model="data.plantCd"
                />
              </div>
              <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2">
                <c-select
                  :editable="editable && !updateMode"
                  codeGroupCd="WEATHER_CD"
                  type="edit"
                  itemText="codeName"
                  itemValue="code"
                  name="weatherCd"
                  label="날씨"
                  v-model="data.weatherCd"
                ></c-select>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2">
                <c-text
                  :editable="editable && !updateMode"
                  label="온도"
                  suffix="℃"
                  name="temperature"
                  v-model="data.temperature"
                >
                </c-text>
              </div>
            </template>
          </c-card>
        </div>
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tabvertical"
          v-if="popupParam.envAirDailyResultId"
        >
          <c-tab
            type="vertical"
            :tabItems.sync="tabItems"
            :inlineLabel="true"
            v-model="tab"
            :dense="true"
            align="left"
            :height="tabHeight"
            :splitter="splitter"
            tabClassVertical="leftTabAlign"
          >
            <template v-slot:default="tab">
              <component :is="tab.component" :param.sync="popupParam" />
            </template>
          </c-tab>
        </div>
      </div>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import { uid } from "quasar";
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "daily-air-report-detail",
  props: {
    popupParam: {
      type: Object,
      default() {
        return {
          envAirDailyResultId: "",
          isFullScreen: false,
          plantCd: null,
          dailyResultDt: "",
          approvalStatusCd: null,
        };
      },
    },
    contentHeight: null,
  },
  data() {
    return {
      splitter: { data: 185 },
      tab: "tab1",
      tabItems: [],
      data: {
        plantCd: null, // 사업장코드
        envAirDailyResultId: "", // 대기일지 일련번호
        dailyResultDt: "", // 작성일
        deptCd: "", // 작성부서
        userId: "", // 작성자
        weatherCd: null, // 날씨
        temperature: "", // 온도
        approvalStatusCd: "",
      },
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        isFull: false,
        width: "80%",
        top: "",
        param: {},
        closeCallback: null,
      },
      saveUrl: transactionConfig.env.air.daily.result.insert.url,
      mappingType: "POST",
      printUrl: "",
      insertUrl: "",
      updateUrl: "",
      deleteUrl: "",
      editable: true,
      isSave: false,
      updateMode: false,
      detailUrl: "",
      isApproval: false,
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    approvalInfo() {
      return {
        sysApprovalRequestId: this.data.sysApprovalRequestId, // 결재요청번호
        /**
         * 결재상태코드
         * ASC0000001	결재중
         * ASC0000002	반려
         * ASC9999999	결재완료
         */
        approvalStatusCd: this.data.approvalStatusCd,
        apprEditable:
          this.data.approvalStatusCd === null ||
          this.data.approvalStatusCd == "ASC0000001", // 결재버튼 활성화 기준
        param: this.data, // 결재 param
        approvalUrl: this.updateUrl, // 결재 url
        isApproval: this.isApproval, // 결재 submit
        approvalTypeCd: "APTC000013", // 결재유형코드
        approvalParamValue: {
          // 결재상세화면 파라미터
          envAirDailyResultId: this.popupParam.envAirDailyResultId,
          plantCd: this.popupParam.plantCd,
          isFullScreen: false,
        },
        approvalRequestName: "대기일지 [" + this.data.dailyResultDt + "]", // 결재요청명 (문서 title)
        approvalConnId: this.popupParam.envAirDailyResultId, // 결재연결용 업무일련번호 (문서 key)
      };
    },
    tabHeight() {
      return String(this.contentHeight - 160);
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.detailUrl = selectConfig.env.air.daily.result.get.url;
      this.printUrl = selectConfig.env.air.daily.result.print.url;
      this.saveUrl = transactionConfig.env.air.daily.result.insert.url;
      this.updateUrl = transactionConfig.env.air.daily.result.update.url;
      this.deleteUrl = transactionConfig.env.air.daily.result.delete.url;
      this.getDetail();
    },
    saveDataAppr() {
      window.getApp.$emit("CONFIRM", {
        title: "LBLCONFIRM",
        message: "결재요청 하기 전 입력된 값을 저장합니다.\n진행하시겠습니까?",
        // TODO : 필요시 추가하세요.
        type: "info", // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.data.regUserId = this.$store.getters.user.userId;
          this.data.chgUserId = this.$store.getters.user.userId;
          let promises = [
            {
              func: this.approvalValue,
            },
          ];
          this.$comm.orderedPromise(promises);
        },
        // 취소 callback 함수
        cancelCallback: () => {},
      });
    },
    // [S] 결재관련
    approvalCallback() {
      // 결재관련 결재요청버튼 callback
      this.$refs["appr-btn"].apprRequestPop();
    },
    approvalValue() {
      return new Promise((resolve) => {
        this.isApproval = !this.isApproval;
        resolve(true);
      });
    },
    getDetail() {
      if (this.popupParam.envAirDailyResultId) {
        this.$http.url = this.detailUrl;
        this.$http.param = {
          envAirDailyResultId: this.popupParam.envAirDailyResultId,
        };
        this.$http.type = "GET";
        this.$http.request((_result) => {
          this.data = _result.data;
          this.updateMode = true;
          this.popupParam.plantCd = this.data.plantCd;
          this.popupParam.dailyResultDt = this.data.dailyResultDt;
          this.popupParam.approvalStatusCd = this.data.approvalStatusCd;
          if (this.tabItems.length == 0) {
            this.tabItems = [
              {
                name: "tab1",
                label: "1. 배출구별 가동(조업)시간",
                component: () =>
                  import(`${"@/pages/env/air/dailyAirReport01.vue"}`),
                key: uid(),
              },
              {
                name: "tab2",
                label: "2. 방지시설 운전사항",
                component: () =>
                  import(`${"@/pages/env/air/dailyAirReport02.vue"}`),
                key: uid(),
              },
              {
                name: "tab3",
                label: "3. 방지시설 보수내역",
                component: () =>
                  import(`${"@/pages/env/air/dailyAirReport03.vue"}`),
                key: uid(),
              },
              {
                name: "tab4",
                label: "4. 연료사용량",
                component: () =>
                  import(`${"@/pages/env/air/dailyAirReport04.vue"}`),
                key: uid(),
              },
              {
                name: "tab5",
                label: "5. 원료사용량",
                component: () =>
                  import(`${"@/pages/env/air/dailyAirReport05.vue"}`),
                key: uid(),
              },
            ];
          }
        });
      } else {
        this.data.dailyResultDt = this.$comm.getToday();
        this.data.userId = this.$store.getters.user.userId;
        this.data.deptCd = this.$store.getters.user.deptCd;
      }
    },
    saveInfo() {
      if (this.popupParam.envAirDailyResultId) {
        this.saveUrl = transactionConfig.env.air.daily.result.update.url;
        this.mappingType = "PUT";
      } else {
        this.saveUrl = transactionConfig.env.air.daily.result.insert.url;
        this.mappingType = "POST";
      }

      this.$refs["editForm"].validate().then((_result) => {
        if (_result) {
          window.getApp.$emit("CONFIRM", {
            title: "LBLCONFIRM",
            message: "MSGSAVE", // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: "info", // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit("APP_VALID_ERROR");
        }
      });
    },
    saveCallback(result) {
      this.popupParam.envAirDailyResultId = result.data.envAirDailyResultId;
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      this.getDetail();
    },
    deleteData() {
      window.getApp.$emit("CONFIRM", {
        title: "LBLCONFIRM",
        message: "일지전체 내용이 삭제됩니다.\r\n삭제하시겠습니까?",
        // TODO : 필요시 추가하세요.
        type: "warning", // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(
            this.deleteUrl,
            this.popupParam.envAirDailyResultId,
          );
          this.$http.type = "DELETE";
          this.$http.request(() => {
            window.getApp.$emit("APP_REQUEST_SUCCESS");
            this.$emit("closePopup");
          });
        },
        // 취소 callback 함수
        cancelCallback: () => {},
      });
    },
    fullScreenReport() {
      this.popupOptions.target = () =>
        import(`${"@/pages/env/air/dailyAirReportFullScreen.vue"}`);
      this.popupOptions.title = "대기일지 전체";
      this.popupOptions.param = {
        envAirDailyResultId: this.popupParam.envAirDailyResultId,
        plantCd: this.popupParam.plantCd,
        isFullScreen: true,
        dailyResultDt: this.popupParam.dailyResultDt,
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    print() {
      // window.open('/대기일지_샘플.xlsx');
      let thisVue = this;
      this.$http.url = this.$format(
        this.printUrl,
        this.popupParam.envAirDailyResultId,
      );
      this.$http.type = "GET";
      this.$http.request(
        (_result) => {
          let fileOrgNm = this.data.dailyResultDt + "_대기일지.xlsx";
          let blob = thisVue.$comm.base64ToBlob(_result.data);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileOrgNm;
            link.click();
          }
        },
        () => {},
      );
    },
  },
};
</script>
